import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import "./NotFound.css"; // Create this CSS file below

const NotFound = () => {
  return (
    <motion.div
      className="notfound-container"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <motion.h1
        className="notfound-title"
        initial={{ y: -40 }}
        animate={{ y: 0 }}
        transition={{ type: "spring", stiffness: 100 }}
      >
        404
      </motion.h1>
      <motion.p
        className="notfound-message"
        initial={{ y: 40, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.2 }}
      >
        Sorry, the page you are looking for does not exist.
      </motion.p>
      <Link to="/" className="notfound-home-btn">
        Go to Homepage
      </Link>
    </motion.div>
  );
};

export default NotFound;
